export default {
      id: "213,4=1,7+35+70+70+35+1,7-usage",
      viewBox: "0 0 1000 1000",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#213,4=1,7+35+70+70+35+1,7",
      toString: function () {
        return this.url;
      }
    }